import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import Search from "@material-ui/icons/Search";
// core components
import boxShadows from "assets/theme/box-shadow.js";

const members = [
  {
    image: require("assets/img/theme/team-1.jpg").default,
    name: "John Michael",
    status: "Online",
    color: "success",
  },
  {
    image: require("assets/img/theme/team-2.jpg").default,
    name: "Alex Smith",
    status: "In a meeting",
    color: "warning",
  },
  {
    image: require("assets/img/theme/team-3.jpg").default,
    name: "Samantha Ivy",
    status: "Offline",
    color: "error",
  },
  {
    image: require("assets/img/theme/team-4.jpg").default,
    name: "John Michelle",
    status: "Online",
    color: "success",
  },
  {
    image: require("assets/img/theme/team-1.jpg").default,
    name: "John Snow",
    status: "Online",
    color: "success",
  },
];

function CardTeamMembersSearch() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          boxShadow: boxShadows.boxShadow + "!important",
          border: "0!important",
        }}
        elevation={0}
      >
        <CardHeader
          subheader="Team members"
          subheaderTypographyProps={{
            component: Box,
            variant: "h3",
            sx: { marginBottom: "0!important", color: theme.palette.dark.main },
          }}
        ></CardHeader>
        <CardHeader
          subheader={
            <>
              <Box sx={{ display: "flex" }}>
                <IconButton type="submit" aria-label="search">
                  <Box
                    component={Search}
                    sx={{
                      width: "1.25rem!important",
                      height: "1.25rem!important",
                    }}
                  />
                </IconButton>
                <InputBase
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-input": {
                      border: "none!important",
                    },
                  }}
                  placeholder="Search"
                  inputProps={{ "aria-label": "search google maps" }}
                />
              </Box>
            </>
          }
          sx={{
            paddingTop: ".25rem!important",
            paddingBottom: ".25rem!important",
          }}
        ></CardHeader>
        <CardContent>
          <List disablePadding>
            {members.map((prop, key) => {
              return (
                <ListItem
                  key={key}
                  sx={{
                    paddingLeft: 0,
                    paddingRight: 0,
                    "&:not(:last-of-type)": {
                      borderBottom: "1px solid " + theme.palette.gray[200],
                    },
                  }}
                >
                  <Grid container component={Box} sx={{ alignItems: "center" }}>
                    <Grid item xs="auto">
                      <Avatar alt="..." src={prop.image} />
                    </Grid>
                    <Grid
                      item
                      sx={{ flexBasis: 0, flexGrow: 1, maxWidth: "100%" }}
                    >
                      <Typography
                        variant="h4"
                        component="h4"
                        sx={{ marginBottom: 0 }}
                      >
                        {prop.name}
                      </Typography>
                      <Box
                        sx={{ color: theme.palette[prop.color].main }}
                        component="span"
                      >
                        ●
                      </Box>
                      <Box
                        sx={{ fontSize: "80%", fontWeight: "400" }}
                        component="small"
                      >
                        {prop.status}
                      </Box>
                    </Grid>
                    <Grid item xs="auto">
                      <Button size="small" variant="contained" color="primary">
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </>
  );
}

export default CardTeamMembersSearch;
